import type { BatchSchedule } from 'lib-shared-types-api';
import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import { usePrevious } from 'react-use';

import { flowsApi } from 'apis/flows';
import { FlowCallActionT } from 'components/powerCallFlow/api/types';
import { FlowEmailActionT } from 'components/powerEmailFlow/api/types';
import { FlowMessengerAction } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';

import { getNodeSchedulesIds } from '../helpers/getNodeScheduleIds';

export type Action = FlowCallActionT | FlowEmailActionT | FlowMessengerAction;

const initSchedules = [];

export const useScheduleFetch = (actions: Action[] | null): BatchSchedule[] => {
  const previousActions = usePrevious(actions);

  const [readSchedules, { schedules }] =
    flowsApi.useLazyReadFlowsSchedulesBatchQuery({
      selectFromResult: ({ data }) => ({
        schedules: data?.data.schedules ?? initSchedules,
      }),
    });

  useEffect(() => {
    if (previousActions === actions) return;

    const nodeScheduleIds = getNodeSchedulesIds(actions);
    const previousNodeScheduleIds = getNodeSchedulesIds(previousActions);

    if (
      !!nodeScheduleIds.length &&
      !isEqual(nodeScheduleIds, previousNodeScheduleIds)
    ) {
      readSchedules({ ids: nodeScheduleIds });
    }
  }, [actions, previousActions, readSchedules]);

  return schedules;
};
